import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

class Navbar extends Component {
  render() {
    return (
      <nav className="navbar navbar-toggleable-md" style={{  backgroundColor: '#2d2d30' }}>
        <button className="navbar-toggler navbar-toggler-right" style={{backgroundColor:'white'}} type="button" data-toggle="collapse" data-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon" ></span>
        </button>
        <div className="container">
          <Link className="navbar-brand" to="/">Cry For Rain</Link>
          <div className="collapse navbar-collapse" id="navbarCollapse">
            <ul className="navbar-nav ml-auto">
              <li className="nav-item active">
                <Link className="nav-link" to="/">HOME <span className="sr-only">(current)</span></Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/bio">BIO</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/book">BOOK</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/news">NEWS</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/contact">CONTACT</Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    );
  }
}

export default Navbar;
